/* Tecán cart discount codes: apply/remove through the Cart AJAX API, then let Dawn re-render the drawer. */
(function () {
  'use strict';
  if (customElements.get('tecan-cart-discount')) return;
  class TecanCartDiscount extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input');
      this.msg = this.querySelector('[data-msg]');
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.apply(this.input.value.trim(), null); });
      this.querySelectorAll('[data-remove]').forEach((b) => b.addEventListener('click', () => this.apply('', b.getAttribute('data-remove'))));
    }
    codes() { return (this.getAttribute('data-codes') || '').split(',').map((c) => c.trim()).filter(Boolean); }
    say(text) { this.msg.textContent = text || ''; this.msg.hidden = !text; }
    busy(on) { this.classList.toggle('is-busy', on); this.querySelectorAll('button, input').forEach((el) => { el.disabled = on; }); }
    async apply(code, remove) {
      var codes = this.codes();
      if (remove) codes = codes.filter((c) => c.toLowerCase() !== remove.toLowerCase());
      else { if (!code) { this.input.focus(); return; } if (!codes.some((c) => c.toLowerCase() === code.toLowerCase())) codes.push(code); }
      this.say('');
      this.busy(true);
      try {
        var cart = await this.update(codes);
        var bad = code && (cart.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase() && !d.applicable);
        if (bad) {
          await this.update(codes.filter((c) => c.toLowerCase() !== code.toLowerCase()));
          this.busy(false);
          this.say(this.getAttribute('data-invalid') || 'This code is not valid.');
          this.input.select();
          return;
        }
        this.rerender(cart);
      } catch (e) {
        this.busy(false);
        this.say(this.getAttribute('data-invalid') || 'Something went wrong.');
      }
    }
    async update(codes) {
      var r = await fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), sections: 'cart-drawer,cart-icon-bubble' })
      });
      if (!r.ok) throw new Error('cart update ' + r.status);
      return r.json();
    }
    rerender(cart) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && cart.sections) { drawer.renderContents(cart); return; }
      window.location.reload();
    }
  }
  customElements.define('tecan-cart-discount', TecanCartDiscount);

  /* Duo upgrade: swap the single bottle(s) for The Tecán Duo. Delegated click (no dependency on custom-element
     timing), two plain Cart API calls (remove, then add), page reload as the universal fallback. */
  var duoBusy = false;
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest && e.target.closest('.tecan-duo-upgrade__btn');
    if (!btn || duoBusy) return;
    e.preventDefault();
    var box = btn.closest('.tecan-duo-upgrade');
    var remove = (box.getAttribute('data-remove') || '').split(',').filter(Boolean);
    var add = box.getAttribute('data-add');
    duoBusy = true; btn.disabled = true; box.classList.add('is-busy');
    var say = function (t) { var m = box.querySelector('.tecan-duo-upgrade__msg'); if (!m) { m = document.createElement('p'); m.className = 'tecan-duo-upgrade__msg'; box.appendChild(m); } m.textContent = t; };
    try {
      var updates = {}; remove.forEach(function (id) { updates[id] = 0; });
      var r1 = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
      if (!r1.ok) throw new Error('remove ' + r1.status);
      var r2 = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(add), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' }) });
      if (!r2.ok) throw new Error('add ' + r2.status);
      var data = await r2.json();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections && box.closest('cart-drawer')) { drawer.renderContents(data); }
      else { window.location.reload(); }
    } catch (err) {
      console.error('[tecan] duo upgrade failed', err);
      say('Something went wrong (' + (err && err.message) + '). Please try again.');
      btn.disabled = false; box.classList.remove('is-busy');
    } finally { duoBusy = false; }
  });
})();
